import React, { useState, Component } from 'react';
import { ChevronLeft, Home, Users, Building2, MessageCircle, Calendar, Bell, Settings, Heart, Star, MapPin, Phone, Mail, Search, Filter, Plus, Edit, Trash2, Download, Upload, Share2, Eye, EyeOff, Check, X, AlertCircle, Info, CheckCircle, XCircle, Sparkles } from 'lucide-react';
interface DesignSystemPageProps {
  onBack: () => void;
}
export function DesignSystemPage({
  onBack
}: DesignSystemPageProps) {
  const [activeTab, setActiveTab] = useState<'colors' | 'typography' | 'buttons' | 'forms' | 'cards' | 'icons'>('colors');
  return <div className="min-h-screen bg-neutral-bg pb-6 font-sans w-full" data-id="element-1105">
      <div className="w-full mx-auto bg-neutral-bg min-h-screen relative" data-id="element-1106">
        {/* Header */}
        <div className="bg-gradient-to-r from-primary to-primary-dark px-4 pt-8 pb-6 sticky top-0 z-10 shadow-lg" data-id="element-1107">
          <button onClick={onBack} className="p-2 -ml-2 text-white hover:bg-white/10 rounded-full transition-colors mb-4" data-id="element-1108">
            <ChevronLeft className="w-6 h-6" data-id="element-1109" />
          </button>
          <h1 className="text-2xl font-bold text-white mb-2" data-id="element-1110">Design System</h1>
          <p className="text-white/80 text-sm" data-id="element-1111">
            Component library and style guide
          </p>
        </div>

        {/* Tabs */}
        <div className="px-4 pt-4 pb-2 sticky top-[120px] z-10 bg-neutral-bg" data-id="element-1112">
          <div className="bg-white rounded-xl p-1 shadow-sm border border-gray-100 flex gap-1 overflow-x-auto no-scrollbar" data-id="element-1113">
            <button onClick={() => setActiveTab('colors')} className={`px-4 py-2 rounded-lg text-xs font-semibold transition-colors whitespace-nowrap ${activeTab === 'colors' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1114">
              Colors
            </button>
            <button onClick={() => setActiveTab('typography')} className={`px-4 py-2 rounded-lg text-xs font-semibold transition-colors whitespace-nowrap ${activeTab === 'typography' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1115">
              Typography
            </button>
            <button onClick={() => setActiveTab('buttons')} className={`px-4 py-2 rounded-lg text-xs font-semibold transition-colors whitespace-nowrap ${activeTab === 'buttons' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1116">
              Buttons
            </button>
            <button onClick={() => setActiveTab('forms')} className={`px-4 py-2 rounded-lg text-xs font-semibold transition-colors whitespace-nowrap ${activeTab === 'forms' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1117">
              Forms
            </button>
            <button onClick={() => setActiveTab('cards')} className={`px-4 py-2 rounded-lg text-xs font-semibold transition-colors whitespace-nowrap ${activeTab === 'cards' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1118">
              Cards
            </button>
            <button onClick={() => setActiveTab('icons')} className={`px-4 py-2 rounded-lg text-xs font-semibold transition-colors whitespace-nowrap ${activeTab === 'icons' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1119">
              Icons
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="px-4 pt-4 space-y-6" data-id="element-1120">
          {/* Colors Tab */}
          {activeTab === 'colors' && <>
              <section data-id="element-1121">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1122">
                  Brand Colors
                </h2>
                <div className="grid grid-cols-2 gap-4" data-id="element-1123">
                  <div className="space-y-2" data-id="element-1124">
                    <div className="bg-primary h-24 rounded-xl shadow-sm flex items-center justify-center" data-id="element-1125">
                      <span className="text-white font-semibold" data-id="element-1126">Primary</span>
                    </div>
                    <p className="text-xs text-gray-600 font-mono" data-id="element-1127">#1E40AF</p>
                  </div>
                  <div className="space-y-2" data-id="element-1128">
                    <div className="bg-secondary h-24 rounded-xl shadow-sm flex items-center justify-center" data-id="element-1129">
                      <span className="text-white font-semibold" data-id="element-1130">
                        Secondary
                      </span>
                    </div>
                    <p className="text-xs text-gray-600 font-mono" data-id="element-1131">#10B981</p>
                  </div>
                  <div className="space-y-2" data-id="element-1132">
                    <div className="bg-accent h-24 rounded-xl shadow-sm flex items-center justify-center" data-id="element-1133">
                      <span className="text-primary font-semibold" data-id="element-1134">Accent</span>
                    </div>
                    <p className="text-xs text-gray-600 font-mono" data-id="element-1135">#FCD34D</p>
                  </div>
                  <div className="space-y-2" data-id="element-1136">
                    <div className="bg-neutral-text h-24 rounded-xl shadow-sm flex items-center justify-center" data-id="element-1137">
                      <span className="text-white font-semibold" data-id="element-1138">Text</span>
                    </div>
                    <p className="text-xs text-gray-600 font-mono" data-id="element-1139">#1F2937</p>
                  </div>
                </div>
              </section>

              <section data-id="element-1140">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1141">
                  Semantic Colors
                </h2>
                <div className="grid grid-cols-2 gap-4" data-id="element-1142">
                  <div className="space-y-2" data-id="element-1143">
                    <div className="bg-green-500 h-20 rounded-xl shadow-sm flex items-center justify-center" data-id="element-1144">
                      <span className="text-white font-semibold" data-id="element-1145">Success</span>
                    </div>
                    <p className="text-xs text-gray-600 font-mono" data-id="element-1146">#10B981</p>
                  </div>
                  <div className="space-y-2" data-id="element-1147">
                    <div className="bg-red-500 h-20 rounded-xl shadow-sm flex items-center justify-center" data-id="element-1148">
                      <span className="text-white font-semibold" data-id="element-1149">Error</span>
                    </div>
                    <p className="text-xs text-gray-600 font-mono" data-id="element-1150">#EF4444</p>
                  </div>
                  <div className="space-y-2" data-id="element-1151">
                    <div className="bg-yellow-500 h-20 rounded-xl shadow-sm flex items-center justify-center" data-id="element-1152">
                      <span className="text-white font-semibold" data-id="element-1153">Warning</span>
                    </div>
                    <p className="text-xs text-gray-600 font-mono" data-id="element-1154">#F59E0B</p>
                  </div>
                  <div className="space-y-2" data-id="element-1155">
                    <div className="bg-blue-500 h-20 rounded-xl shadow-sm flex items-center justify-center" data-id="element-1156">
                      <span className="text-white font-semibold" data-id="element-1157">Info</span>
                    </div>
                    <p className="text-xs text-gray-600 font-mono" data-id="element-1158">#3B82F6</p>
                  </div>
                </div>
              </section>

              <section data-id="element-1159">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1160">
                  Neutral Colors
                </h2>
                <div className="space-y-2" data-id="element-1161">
                  <div className="bg-gray-50 h-16 rounded-xl border border-gray-200 flex items-center px-4" data-id="element-1162">
                    <span className="text-gray-900 font-medium" data-id="element-1163">Gray 50</span>
                  </div>
                  <div className="bg-gray-100 h-16 rounded-xl flex items-center px-4" data-id="element-1164">
                    <span className="text-gray-900 font-medium" data-id="element-1165">Gray 100</span>
                  </div>
                  <div className="bg-gray-200 h-16 rounded-xl flex items-center px-4" data-id="element-1166">
                    <span className="text-gray-900 font-medium" data-id="element-1167">Gray 200</span>
                  </div>
                  <div className="bg-gray-300 h-16 rounded-xl flex items-center px-4" data-id="element-1168">
                    <span className="text-gray-900 font-medium" data-id="element-1169">Gray 300</span>
                  </div>
                  <div className="bg-gray-400 h-16 rounded-xl flex items-center px-4" data-id="element-1170">
                    <span className="text-white font-medium" data-id="element-1171">Gray 400</span>
                  </div>
                  <div className="bg-gray-500 h-16 rounded-xl flex items-center px-4" data-id="element-1172">
                    <span className="text-white font-medium" data-id="element-1173">Gray 500</span>
                  </div>
                  <div className="bg-gray-600 h-16 rounded-xl flex items-center px-4" data-id="element-1174">
                    <span className="text-white font-medium" data-id="element-1175">Gray 600</span>
                  </div>
                  <div className="bg-gray-700 h-16 rounded-xl flex items-center px-4" data-id="element-1176">
                    <span className="text-white font-medium" data-id="element-1177">Gray 700</span>
                  </div>
                </div>
              </section>
            </>}

          {/* Typography Tab */}
          {activeTab === 'typography' && <>
              <section data-id="element-1178">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1179">
                  Headings
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 space-y-4" data-id="element-1180">
                  <h1 className="text-4xl font-bold text-neutral-text" data-id="element-1181">
                    Heading 1
                  </h1>
                  <h2 className="text-3xl font-bold text-neutral-text" data-id="element-1182">
                    Heading 2
                  </h2>
                  <h3 className="text-2xl font-bold text-neutral-text" data-id="element-1183">
                    Heading 3
                  </h3>
                  <h4 className="text-xl font-bold text-neutral-text" data-id="element-1184">
                    Heading 4
                  </h4>
                  <h5 className="text-lg font-bold text-neutral-text" data-id="element-1185">
                    Heading 5
                  </h5>
                  <h6 className="text-base font-bold text-neutral-text" data-id="element-1186">
                    Heading 6
                  </h6>
                </div>
              </section>

              <section data-id="element-1187">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1188">
                  Body Text
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 space-y-4" data-id="element-1189">
                  <p className="text-base text-gray-900" data-id="element-1190">
                    Regular body text - Lorem ipsum dolor sit amet, consectetur
                    adipiscing elit.
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-1191">
                    Small text - Lorem ipsum dolor sit amet, consectetur
                    adipiscing elit.
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1192">
                    Extra small text - Lorem ipsum dolor sit amet, consectetur
                    adipiscing elit.
                  </p>
                  <p className="text-base font-semibold text-gray-900" data-id="element-1193">
                    Semibold text - Lorem ipsum dolor sit amet.
                  </p>
                  <p className="text-base font-bold text-gray-900" data-id="element-1194">
                    Bold text - Lorem ipsum dolor sit amet.
                  </p>
                </div>
              </section>
            </>}

          {/* Buttons Tab */}
          {activeTab === 'buttons' && <>
              <section data-id="element-1195">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1196">
                  Primary Buttons
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 space-y-4" data-id="element-1197">
                  <button className="w-full bg-primary hover:bg-primary-dark text-white font-bold py-4 rounded-xl transition-colors" data-id="element-1198">
                    Primary Button
                  </button>
                  <button className="w-full bg-secondary hover:bg-secondary-dark text-white font-bold py-4 rounded-xl transition-colors" data-id="element-1199">
                    Secondary Button
                  </button>
                  <button className="w-full bg-gradient-to-r from-primary to-primary-dark hover:from-primary-dark hover:to-primary text-white font-bold py-4 rounded-xl transition-all shadow-lg" data-id="element-1200">
                    Gradient Button
                  </button>
                </div>
              </section>

              <section data-id="element-1201">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1202">
                  Outline Buttons
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 space-y-4" data-id="element-1203">
                  <button className="w-full border-2 border-primary text-primary hover:bg-primary hover:text-white font-bold py-4 rounded-xl transition-colors" data-id="element-1204">
                    Outline Primary
                  </button>
                  <button className="w-full border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-bold py-4 rounded-xl transition-colors" data-id="element-1205">
                    Outline Secondary
                  </button>
                </div>
              </section>

              <section data-id="element-1206">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1207">
                  Button Sizes
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 space-y-4" data-id="element-1208">
                  <button className="w-full bg-primary text-white font-bold py-2 rounded-lg text-sm" data-id="element-1209">
                    Small Button
                  </button>
                  <button className="w-full bg-primary text-white font-bold py-3 rounded-xl text-base" data-id="element-1210">
                    Medium Button
                  </button>
                  <button className="w-full bg-primary text-white font-bold py-4 rounded-xl text-lg" data-id="element-1211">
                    Large Button
                  </button>
                </div>
              </section>

              <section data-id="element-1212">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1213">
                  Icon Buttons
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1214">
                  <div className="flex gap-3 flex-wrap" data-id="element-1215">
                    <button className="p-3 bg-primary text-white rounded-full hover:bg-primary-dark transition-colors" data-id="element-1216">
                      <Plus className="w-5 h-5" data-id="element-1217" />
                    </button>
                    <button className="p-3 bg-secondary text-white rounded-full hover:bg-secondary-dark transition-colors" data-id="element-1218">
                      <Edit className="w-5 h-5" data-id="element-1219" />
                    </button>
                    <button className="p-3 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors" data-id="element-1220">
                      <Trash2 className="w-5 h-5" data-id="element-1221" />
                    </button>
                    <button className="p-3 bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 transition-colors" data-id="element-1222">
                      <Share2 className="w-5 h-5" data-id="element-1223" />
                    </button>
                  </div>
                </div>
              </section>

              <section data-id="element-1224">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1225">
                  Glassmorphic Button
                </h2>
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1226">
                  <button className="w-full px-6 py-3 rounded-full backdrop-blur-md bg-white/10 border border-white/20 hover:bg-white/20 transition-all flex items-center justify-center gap-2 shadow-lg" data-id="element-1227">
                    <Sparkles className="w-5 h-5 text-purple-600" data-id="element-1228" />
                    <span className="text-sm font-semibold text-gray-700" data-id="element-1229">
                      Ask AI
                    </span>
                  </button>
                </div>
              </section>
            </>}

          {/* Forms Tab */}
          {activeTab === 'forms' && <>
              <section data-id="element-1230">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1231">
                  Input Fields
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 space-y-4" data-id="element-1232">
                  <div data-id="element-1233">
                    <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1234">
                      Text Input
                    </label>
                    <input type="text" placeholder="Enter text..." className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-secondary/20 focus:border-secondary" data-id="element-1235" />
                  </div>

                  <div data-id="element-1236">
                    <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1237">
                      Email Input
                    </label>
                    <input type="email" placeholder="email@example.com" className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-secondary/20 focus:border-secondary" data-id="element-1238" />
                  </div>

                  <div data-id="element-1239">
                    <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1240">
                      Search Input
                    </label>
                    <div className="relative" data-id="element-1241">
                      <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1242" />
                      <input type="text" placeholder="Search..." className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-secondary/20 focus:border-secondary" data-id="element-1243" />
                    </div>
                  </div>

                  <div data-id="element-1244">
                    <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1245">
                      Textarea
                    </label>
                    <textarea rows={4} placeholder="Enter description..." className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-secondary/20 focus:border-secondary resize-none" data-id="element-1246" />
                  </div>
                </div>
              </section>

              <section data-id="element-1247">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1248">
                  Select & Dropdown
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 space-y-4" data-id="element-1249">
                  <div data-id="element-1250">
                    <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1251">
                      Select Dropdown
                    </label>
                    <select className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-secondary/20 focus:border-secondary bg-white" data-id="element-1252">
                      <option data-id="element-1253">Option 1</option>
                      <option data-id="element-1254">Option 2</option>
                      <option data-id="element-1255">Option 3</option>
                    </select>
                  </div>
                </div>
              </section>

              <section data-id="element-1256">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1257">
                  Checkboxes & Radio
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 space-y-4" data-id="element-1258">
                  <div className="space-y-3" data-id="element-1259">
                    <label className="flex items-center gap-3 cursor-pointer" data-id="element-1260">
                      <input type="checkbox" className="w-5 h-5 text-secondary border-gray-300 rounded focus:ring-secondary" data-id="element-1261" />
                      <span className="text-sm text-gray-700" data-id="element-1262">
                        Checkbox Option 1
                      </span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer" data-id="element-1263">
                      <input type="checkbox" className="w-5 h-5 text-secondary border-gray-300 rounded focus:ring-secondary" defaultChecked data-id="element-1264" />
                      <span className="text-sm text-gray-700" data-id="element-1265">
                        Checkbox Option 2
                      </span>
                    </label>
                  </div>

                  <div className="space-y-3 pt-4 border-t border-gray-100" data-id="element-1266">
                    <label className="flex items-center gap-3 cursor-pointer" data-id="element-1267">
                      <input type="radio" name="radio-group" className="w-5 h-5 text-secondary border-gray-300 focus:ring-secondary" data-id="element-1268" />
                      <span className="text-sm text-gray-700" data-id="element-1269">
                        Radio Option 1
                      </span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer" data-id="element-1270">
                      <input type="radio" name="radio-group" className="w-5 h-5 text-secondary border-gray-300 focus:ring-secondary" defaultChecked data-id="element-1271" />
                      <span className="text-sm text-gray-700" data-id="element-1272">
                        Radio Option 2
                      </span>
                    </label>
                  </div>
                </div>
              </section>
            </>}

          {/* Cards Tab */}
          {activeTab === 'cards' && <>
              <section data-id="element-1273">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1274">
                  Basic Cards
                </h2>
                <div className="space-y-4" data-id="element-1275">
                  <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100" data-id="element-1276">
                    <h3 className="font-bold text-neutral-text mb-2" data-id="element-1277">
                      Card Title
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-1278">
                      This is a basic card with shadow and border.
                    </p>
                  </div>

                  <div className="bg-white rounded-xl p-5 shadow-md" data-id="element-1279">
                    <h3 className="font-bold text-neutral-text mb-2" data-id="element-1280">
                      Card with Medium Shadow
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-1281">
                      This card has a medium shadow for more elevation.
                    </p>
                  </div>

                  <div className="bg-white rounded-xl p-5 shadow-lg" data-id="element-1282">
                    <h3 className="font-bold text-neutral-text mb-2" data-id="element-1283">
                      Card with Large Shadow
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-1284">
                      This card has a large shadow for maximum elevation.
                    </p>
                  </div>
                </div>
              </section>

              <section data-id="element-1285">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1286">
                  Gradient Cards
                </h2>
                <div className="space-y-4" data-id="element-1287">
                  <div className="bg-gradient-to-r from-primary to-primary-dark rounded-xl p-5 text-white shadow-lg" data-id="element-1288">
                    <h3 className="font-bold mb-2" data-id="element-1289">Primary Gradient Card</h3>
                    <p className="text-sm text-white/90" data-id="element-1290">
                      Card with primary gradient background.
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-secondary to-secondary-dark rounded-xl p-5 text-white shadow-lg" data-id="element-1291">
                    <h3 className="font-bold mb-2" data-id="element-1292">Secondary Gradient Card</h3>
                    <p className="text-sm text-white/90" data-id="element-1293">
                      Card with secondary gradient background.
                    </p>
                  </div>
                </div>
              </section>

              <section data-id="element-1294">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1295">
                  Alert Cards
                </h2>
                <div className="space-y-4" data-id="element-1296">
                  <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex gap-3" data-id="element-1297">
                    <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-1298" />
                    <div data-id="element-1299">
                      <p className="text-sm font-semibold text-green-900 mb-1" data-id="element-1300">
                        Success
                      </p>
                      <p className="text-xs text-green-700" data-id="element-1301">
                        Your action was completed successfully.
                      </p>
                    </div>
                  </div>

                  <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex gap-3" data-id="element-1302">
                    <XCircle className="w-5 h-5 text-red-600 flex-shrink-0" data-id="element-1303" />
                    <div data-id="element-1304">
                      <p className="text-sm font-semibold text-red-900 mb-1" data-id="element-1305">
                        Error
                      </p>
                      <p className="text-xs text-red-700" data-id="element-1306">
                        Something went wrong. Please try again.
                      </p>
                    </div>
                  </div>

                  <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex gap-3" data-id="element-1307">
                    <AlertCircle className="w-5 h-5 text-yellow-600 flex-shrink-0" data-id="element-1308" />
                    <div data-id="element-1309">
                      <p className="text-sm font-semibold text-yellow-900 mb-1" data-id="element-1310">
                        Warning
                      </p>
                      <p className="text-xs text-yellow-700" data-id="element-1311">
                        Please review this information carefully.
                      </p>
                    </div>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex gap-3" data-id="element-1312">
                    <Info className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-1313" />
                    <div data-id="element-1314">
                      <p className="text-sm font-semibold text-blue-900 mb-1" data-id="element-1315">
                        Information
                      </p>
                      <p className="text-xs text-blue-700" data-id="element-1316">
                        Here's some helpful information for you.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </>}

          {/* Icons Tab */}
          {activeTab === 'icons' && <>
              <section data-id="element-1317">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1318">
                  Common Icons
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1319">
                  <div className="grid grid-cols-4 gap-6" data-id="element-1320">
                    <div className="flex flex-col items-center gap-2" data-id="element-1321">
                      <Home className="w-6 h-6 text-gray-600" data-id="element-1322" />
                      <span className="text-xs text-gray-500" data-id="element-1323">Home</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1324">
                      <Users className="w-6 h-6 text-gray-600" data-id="element-1325" />
                      <span className="text-xs text-gray-500" data-id="element-1326">Users</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1327">
                      <Building2 className="w-6 h-6 text-gray-600" data-id="element-1328" />
                      <span className="text-xs text-gray-500" data-id="element-1329">Building</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1330">
                      <MessageCircle className="w-6 h-6 text-gray-600" data-id="element-1331" />
                      <span className="text-xs text-gray-500" data-id="element-1332">Chat</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1333">
                      <Calendar className="w-6 h-6 text-gray-600" data-id="element-1334" />
                      <span className="text-xs text-gray-500" data-id="element-1335">Calendar</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1336">
                      <Bell className="w-6 h-6 text-gray-600" data-id="element-1337" />
                      <span className="text-xs text-gray-500" data-id="element-1338">Bell</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1339">
                      <Settings className="w-6 h-6 text-gray-600" data-id="element-1340" />
                      <span className="text-xs text-gray-500" data-id="element-1341">Settings</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1342">
                      <Heart className="w-6 h-6 text-gray-600" data-id="element-1343" />
                      <span className="text-xs text-gray-500" data-id="element-1344">Heart</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1345">
                      <Star className="w-6 h-6 text-gray-600" data-id="element-1346" />
                      <span className="text-xs text-gray-500" data-id="element-1347">Star</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1348">
                      <MapPin className="w-6 h-6 text-gray-600" data-id="element-1349" />
                      <span className="text-xs text-gray-500" data-id="element-1350">Location</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1351">
                      <Phone className="w-6 h-6 text-gray-600" data-id="element-1352" />
                      <span className="text-xs text-gray-500" data-id="element-1353">Phone</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1354">
                      <Mail className="w-6 h-6 text-gray-600" data-id="element-1355" />
                      <span className="text-xs text-gray-500" data-id="element-1356">Mail</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1357">
                      <Search className="w-6 h-6 text-gray-600" data-id="element-1358" />
                      <span className="text-xs text-gray-500" data-id="element-1359">Search</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1360">
                      <Filter className="w-6 h-6 text-gray-600" data-id="element-1361" />
                      <span className="text-xs text-gray-500" data-id="element-1362">Filter</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1363">
                      <Plus className="w-6 h-6 text-gray-600" data-id="element-1364" />
                      <span className="text-xs text-gray-500" data-id="element-1365">Plus</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1366">
                      <Edit className="w-6 h-6 text-gray-600" data-id="element-1367" />
                      <span className="text-xs text-gray-500" data-id="element-1368">Edit</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1369">
                      <Trash2 className="w-6 h-6 text-gray-600" data-id="element-1370" />
                      <span className="text-xs text-gray-500" data-id="element-1371">Delete</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1372">
                      <Download className="w-6 h-6 text-gray-600" data-id="element-1373" />
                      <span className="text-xs text-gray-500" data-id="element-1374">Download</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1375">
                      <Upload className="w-6 h-6 text-gray-600" data-id="element-1376" />
                      <span className="text-xs text-gray-500" data-id="element-1377">Upload</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1378">
                      <Share2 className="w-6 h-6 text-gray-600" data-id="element-1379" />
                      <span className="text-xs text-gray-500" data-id="element-1380">Share</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1381">
                      <Eye className="w-6 h-6 text-gray-600" data-id="element-1382" />
                      <span className="text-xs text-gray-500" data-id="element-1383">View</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1384">
                      <Check className="w-6 h-6 text-gray-600" data-id="element-1385" />
                      <span className="text-xs text-gray-500" data-id="element-1386">Check</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1387">
                      <X className="w-6 h-6 text-gray-600" data-id="element-1388" />
                      <span className="text-xs text-gray-500" data-id="element-1389">Close</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1390">
                      <Sparkles className="w-6 h-6 text-gray-600" data-id="element-1391" />
                      <span className="text-xs text-gray-500" data-id="element-1392">AI</span>
                    </div>
                  </div>
                </div>
              </section>

              <section data-id="element-1393">
                <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1394">
                  Icon Sizes
                </h2>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1395">
                  <div className="flex items-end gap-6" data-id="element-1396">
                    <div className="flex flex-col items-center gap-2" data-id="element-1397">
                      <Home className="w-4 h-4 text-gray-600" data-id="element-1398" />
                      <span className="text-xs text-gray-500" data-id="element-1399">Small</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1400">
                      <Home className="w-6 h-6 text-gray-600" data-id="element-1401" />
                      <span className="text-xs text-gray-500" data-id="element-1402">Medium</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1403">
                      <Home className="w-8 h-8 text-gray-600" data-id="element-1404" />
                      <span className="text-xs text-gray-500" data-id="element-1405">Large</span>
                    </div>
                    <div className="flex flex-col items-center gap-2" data-id="element-1406">
                      <Home className="w-12 h-12 text-gray-600" data-id="element-1407" />
                      <span className="text-xs text-gray-500" data-id="element-1408">XL</span>
                    </div>
                  </div>
                </div>
              </section>
            </>}
        </div>
      </div>
    </div>;
}